export default function FinalForm (){
    let labelSt = 'font-montserrat text-[17px] sm:text-[1.2rem]'
    return (
        <div className="w-[70vw] sm:flex sm:mb-24 bg-[#252121] shadow-lg shadow-black rounded-xl place-self-center p-10 text-white justify-center">
            <div className=" pb-[1rem] sm:pb-[90px]">
                <p className="font-montserrat text-[20px] sm:text-[40px] my-5 text-center">Get in touch, let's create magic<br/> together!</p>
            <div>
            <form action="https://formspree.io/f/mayrrgly"
  method="POST" className="grid">
  <label className={labelSt}>
    Your Email<br></br>
    <input rows={1} type="email" className="rounded w-full text-black invalid:border-red-500 border-[2px]"/>
  </label>
  <div className=" mt-3 sm:mt-10 justify-center items-center mb-5">
  <label className={labelSt}>
    Your Message <br></br>
    <textarea rows={4} className="rounded w-full text-black"  name="message"></textarea>
  </label>
  </div>
  <button type="submit" className="w-full text-white font-montserrat bg-[#6B8E23] px-8 py-4 rounded hover:bg-[#556B2F] duration-300 ease-in-out mb-5 sm:mb-0">Send</button>
</form>
</div>
            </div>
        </div>
    )
}
